// src/routes/RouterConfig.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { paths } from "./paths";
import { useLocation } from "react-router-dom";
// Layout
import DashboardLayout from "../layouts/DashboardLayout";
import { UploadProvider } from "../store/uploadContext";
// Pages
import LandingPage from "../pages/LandingPage";
import SignIn from "../pages/UserManagement/Login";
import Signup from "../pages/UserManagement/SignUp";
import ForgotPwd from "../pages/UserManagement/ForgotPwd";
import ResetPwd from "../pages/UserManagement/ResetPwd";
import JobManagement from "../pages/Dashboard/Job/JobManagement";
import Application from "../pages/Dashboard/Application/Application";
import Report from "../pages/Dashboard/Report/Report";
import Interview from "../pages/Dashboard/Interview/Interview";
import InterviewConfig from "../pages/Dashboard/Interview/InterviewConfig";
import Ranking from "../pages/Dashboard/Interview/Ranking";
import ScreeningDashboard from "../pages/Dashboard/Screening";
import UserManagement from "../pages/Dashboard/Users/UserManagement";
import InterviewPage from "../pages/Dashboard/Demo/InterviewPage";
import SlotSelection from "../pages/Dashboard/Interview/SlotSelection";
import ChatInterface from "../pages/Dashboard/Interview/ChatInterface";
import ScheduledChat from "../pages/Dashboard/Interview/ScheduledChat";
import PrivateRoute from "./PrivateRoute";
import PrivacyPolicy from "../pages/LandingPage/PrivacyPolicy";
import TermsOfService from "../pages/LandingPage/TermsOfService";
import ResumePoolSearch from "../pages/Dashboard/ResumePool";
import Companies from "../pages/Dashboard/Company";
import ReleaseNotes from "../pages/Release";
import DemoPage from "../pages/LandingPage/DemoPage";
import LandingLayout from "../layouts/LandingLayout";
import CandidateDetails from "../pages/Dashboard/Report/CandidateDetails";
import CompanyUsers from "../pages/Dashboard/Admin/CompanyUsers";
// The Console revamp. Self-contained under /v1 — see src/v1/routes/V1Routes.js.
import v1Routes from "../v1/routes/V1Routes";


const ChatRouter = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode");

  return mode === "s" ? <ScheduledChat /> : <ChatInterface />;
};

const RouterConfig = () => {
  return (
    <Routes>
      <Route path={paths.landing} element={<LandingLayout />}>
        <Route index element={<LandingPage />} />
        <Route path={paths.demo.demoPage.substring(1)} element={<DemoPage />} />
        <Route
          path={paths.instantInterview.instantInterview.substring(1)}
          element={<InterviewPage />}
        />
        <Route
          path={paths.legal.privacyPolicy.substring(paths.landing.length)}
          element={<PrivacyPolicy />}
        />
        <Route
          path={paths.legal.termsOfService.substring(paths.landing.length)}
          element={<TermsOfService />}
        />
      </Route>
      {/* Auth Routes */}
      <Route path={paths.auth.signin} element={<SignIn />} />
      <Route path={paths.auth.signup} element={<Signup />} />
      <Route path={paths.auth.forgotPassword} element={<ForgotPwd />} />
      <Route path={paths.auth.resetPassword} element={<ResetPwd />} />

      {/* Dashboard Routes */}
      <Route
        path={paths.dashboard.root}
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to={paths.dashboard.jobs} replace />} />
        <Route path={paths.dashboard.jobs} element={<JobManagement />} />
        {/* Applications routes */}
        <Route
          path={paths.dashboard.applications}
          element={
            <UploadProvider>
              <Application />
            </UploadProvider>
          }
        />
        <Route
          path={paths.dashboard.applicationsWithJobId}
          element={
            <UploadProvider>
              <Application />
            </UploadProvider>
          }
        />
        <Route path={paths.dashboard.reports} element={<Report />} />
        <Route path={paths.dashboard.reportsWithJobId} element={<Report />} />

        {/* Interviews routes */}
        <Route path={paths.dashboard.interviews} element={<Interview />} />
        <Route
          path={paths.dashboard.interviewsWithJobId}
          element={<Interview />}
        />
        <Route path={paths.dashboard.interviewConfig} element={<InterviewConfig />} />
        <Route
          path={paths.dashboard.interviewConfigWithJobId}
          element={<InterviewConfig />}
        />

        {/* Rankings routes */}
        <Route path={paths.dashboard.rankings} element={<Ranking />} />
        <Route path={paths.dashboard.rankingsWithJobId} element={<Ranking />} />

        {/* Screening routes */}
        <Route path={paths.dashboard.screening} element={<ScreeningDashboard />} />
        <Route path={paths.dashboard.screeningWithJobId} element={<ScreeningDashboard />} />

        {/* <Route path={paths.dashboard.users} element={<UserManagement />} /> */}
        <Route path={paths.dashboard.demo} element={<InterviewPage />} />
        <Route
          path={paths.dashboard.resumePool}
          element={<ResumePoolSearch />}
        />
        <Route path={paths.dashboard.companies} element={<Companies />} />
        <Route path={paths.dashboard.companyUsers} element={<CompanyUsers />} />
      </Route>

      {/* Interview Routes */}
      <Route path={paths.interview.slot} element={<SlotSelection />} />
      <Route path={paths.interview.chat} element={<ChatRouter />} />

      {/* Candidate Details Route */}
      <Route path={paths.candidate.details} element={<CandidateDetails />} />

      {/* Release Notes */}
      <Route path={paths.release.releaseNotes} element={<ReleaseNotes />} />

      {/* Console revamp — runs alongside the original UI, sharing services + store. */}
      {v1Routes}

      {/* Catch all */}
      <Route path="*" element={<Navigate to={paths.landing} replace />} />
    </Routes>
  );
};

export default RouterConfig;
